import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class LogNavigationService {

  private navigationStartedAt = 0;

  constructor(
    private router: Router,
    logger: NGXLogger
  ) {

    this.router.events.subscribe({
      next: (event) => {
        if (event instanceof NavigationStart) {
          // Ne loguje se posebno — samo meri trajanje: jedna linija po navigaciji umesto dve.
          this.navigationStartedAt = Date.now();
        }

        if (event instanceof NavigationEnd) {
          logger.log(`Navigation to ${event.urlAfterRedirects} (${Date.now() - this.navigationStartedAt}ms)`);
        }

        // Slučajevi koji su za debug najzanimljiviji ranije se uopšte nisu logovali:
        if (event instanceof NavigationCancel) {
          // guard/redirect prekid — očekivana pojava, zato samo debug
          logger.debug(`Navigation to ${event.url} canceled (${Date.now() - this.navigationStartedAt}ms): ${event.reason || 'code ' + event.code}`);
        }

        if (event instanceof NavigationError) {
          // pukla lazy ruta (npr. ChunkLoadError posle novog deploya) ili greška u resolver-u
          logger.error(`Navigation to ${event.url} failed`, event.error);
        }
      }
    }
    );
  }

}
